<template>
    <div
        :class="{ opened: value }"
        class="cr-modal pos-bottom"
        :style="{ top: 'unset !important' }"
    >
        <div class="cr-modal-dialog mx-0 my-0">
            <Scrollable class="card overflow-hidden pos-fixed pos-bottom">
                <template v-if="$slots.title" v-slot:fixed-top>
                    <slot name="header">
                        <div
                            class="card-block card-toolbar pb-0"
                            :style="{
                                borderBottom: 'none !important',
                            }"
                        >
                            <span class="h5 card-title"
                                ><strong><slot name="title" /></strong
                            ></span>
                            <span
                                v-if="showCloseBtn && allowDismiss"
                                aria-label="Fechar"
                                class="icon-cr icon-close"
                                @click="$emit('close-modal')"
                            />
                        </div>
                    </slot>
                    <slot name="fixed-top" />
                </template>
                <slot />
                <template v-slot:fixed-bottom>
                    <slot name="fixed-bottom" />
                </template>
            </Scrollable>
        </div>
    </div>
</template>

<script>
    import Modal from '../common/container/Modal';

    export default {
        name: 'SelectorModal',
        extends: Modal,

        props: {
            value: {
                default: false,
            },
            closeModal: {
                default: false,
            },
        },
    };
</script>
